import { render } from "./showNewsAcademic.vue?vue&type=template&id=eac24f0a"
import script from "./showNewsAcademic.vue?vue&type=script&lang=js"
export * from "./showNewsAcademic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__